<template>
    <div>
        <div v-if="subcriptionList.length > 0">
            <HistoryItem v-for="(subcription, index) in subcriptionList"
                    :key="index"
                    :purchase="subcription"
                    @onClickPurchase="clickPurchase(subcription)"
            ></HistoryItem>
        </div>
    </div>
</template>

<script>
//mixins
import ModalMixin from '@/mixin/ModalMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import HistoryItem from "../../History/component/HistoryRedeem/HistoryItem.vue"
//service
import Subscription from '../service/subscription.js'
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';

export default {
    name: 'Subcription',
    mixins: [ModalMixin, ErrorApiMixin],
    components: {
        HistoryItem,
    },
    data: function() {
        return {
            subcriptionList: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
            isSerialLoading: false,
        };
    },
    created: function() {
        this.getList();
    },
    methods: {
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                Subscription.apiGetSubscriptionCoupon().subscribe({
                    next: (res) => {
                        this.subcriptionList = res;
                        // console.log('subcriptionList', this.subcriptionList);
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.subcriptionList.length > 0;
                        resolve(true);
                    },
                    error: (error) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(error);
                        resolve(null);
                    }
                });
            });
        },
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            if (this.isShowSerialModal(purchase)) {
                this.openSerial(purchase);
            }
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modal.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .show();
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }

            return true;
        },
    }
}
</script>
<style lang="scss" scoped>
    .no-data {
        min-height: calc(100vh - 150px);
    }
</style>